import React, { useEffect } from 'react'
import CommonBanner from '../Common/CommonBanner'
import banner from "../../Assets/images/agb2.webp";
import { useDispatch } from 'react-redux';
import { setHeaderColor, setloading } from '../../Redux/ActionCreater';
const Agb = () => {
     let dispatch = useDispatch()
      useEffect(() => {
          dispatch(setHeaderColor("#facee1"));
          window.scrollTo(0, 0);
           dispatch(setloading(false));
        }, [])
  return (
    <div>
      <CommonBanner slug={"agb"}/>
      <section class="toppara impressumcontainer">
        <div class="container">
          <div className="row">
            <div className="col-12">
              <h4>§ 1 Geltungsbereich, Vertragssprache</h4>
              <p>(1) Die vorliegenden Allgemeinen Geschäftsbedingungen (nachfolgend „AGB“), finden Anwendung
für Bestellungen von Waren aus dem Sortiment unseres Online-Shops auf www.shapebysarah.com.</p>
 <p>(2) Dein Vertragspartner für Bestellungen in unserem Online-
Shop ist:<br/>
SHAPE BY SARAH ECOMMERCE – FZCO, Dubai<br/>
Silicon Oasis, DDP, Building A1/A2, Dubai, United<br/>
Arab Emirates<br/>
Telefon: +491706794214<br/>
E-Mail: support@shapebysarah.com<br/>
(nachfolgend „wir“)</p>
<p>Die für den Vertragsschluss zur Verfügung stehende
Sprache ist ausschließlich Deutsch.</p>
              <h4>§ 2 Anwendbares Recht, zwingende Verbraucherschutzvorschriften</h4>
              <p>Es gilt das Recht der Bundesrepublik Deutschland unter
Ausschluss des UN-Kaufrechts, wenn</p>
<p>Es gilt das Recht der Bundesrepublik Deutschland unter
Ausschluss des UN-Kaufrechts, wenn</p>
<p>a) du deinen gewöhnlichen Aufenthalt in Deutschland hast,
oder</p>
<p>b) dein gewöhnlicher Aufenthalt in einem Staat ist, der nicht
Mitglied der Europäischen Union ist.</p>
<p>Für den Fall, dass du deinen gewöhnlichen Aufenthalt in einem
Mitgliedsland der Europäischen Union hast, gilt ebenfalls die
Anwendbarkeit des deutschen Rechts, wobei zwingende
Bestimmungen des Staates, in dem du deinen gewöhnlichen
Aufenthalt hast, unberührt bleiben.</p>
<h4>§ 3 Zustandekommen des Vertrags</h4>
<p>(1) Die Darstellung der Waren in unserem Online-Shop stellt
kein rechtlich bindendes Angebot, sondern eine
Aufforderung zur Bestellung („invitatio ad offerendum“)
dar.</p>
<p>(2) Durch Anklicken des „Zahlungspflichtig bestellen“-
Buttons im letzten Schritt des Bestellprozesses gibst du
ein verbindliches Angebot zum Kauf der in der
Bestellübersicht angezeigten Waren ab. Zudem
akzeptierst du durch Setzen der jeweiligen Häkchen die
Geltung dieser AGB und unserer Widerrufsbelehrung.</p>
<p>(3) Unmittelbar nach Absenden der Bestellung erhältst du
eine automatisch versendete Bestellbestätigung per E-
Mail, die jedoch noch keine Annahme deines
Vertragsangebots darstellt.</p>
<p>(4) Ein Vertrag zwischen dir und uns kommt erst zustande,
sobald wir deine Bestellung durch eine gesonderte E-Mail
(Auftragsbestätigung
oder
Versandbestätigung)
annehmen. Bitte überprüfe regelmäßig den Spam-Ordner
deines E-Mail-Postfachs.</p>
<p>(5) Wir sind berechtigt, deine Bestellung nach eigenem
Ermessen abzulehnen. Bestellungen können wir
beispielsweise ablehnen, wenn Waren in unserem
Online-Shop angezeigt werden, die zum Zeitpunkt deiner
Bestellung jedoch nicht mehr verfügbar sind.</p>
<p>(6) Erfolgt keine Annahme deiner Bestellung, werden wir dich
per E-Mail darüber informieren, dass deine Bestellung
nicht angenommen wurde.</p>
              <h4>§ 4 Technische Schritte bis zum Vertragsschluss und
Berichtigung von Eingabefehlern</h4>
              <p>(1) Im Rahmen des Bestellprozesses legst du zunächst die
gewünschten Waren in den digitalen Warenkorb. Dort
kannst du jederzeit die gewünschte Stückzahl ändern
oder ausgewählte Waren aus dem digitalen Warenkorb
wieder ganz entfernen.</p>
              <p>(2) Sofern du Waren im digitalen Warenkorb hinterlegt hast,
gelangst du durch einen Klick auf den „Zur Kasse“-Button
auf eine Seite, auf der du deine Daten, insbesondere
Lieferanschrift und Rechnungsadresse eingeben, die
Zahlungsart auswählen sowie eine Bestellübersicht
erkennen kannst.</p>
<p>(3) Schließlich öffnet sich eine Übersichtsseite, auf der du
deine Angaben überprüfen kannst. Deine Eingabefehler
(z.B. bzgl. Bezahlart, Daten oder der gewünschten Stückzahl) kannst du korrigieren, indem du bei dem
jeweiligen Feld auf „Bearbeiten“ klickst. Falls du den
Bestellprozess komplett abbrechen möchten, kannst du
auch einfach dein Browser-Fenster schließen. Ansonsten
wird nach Anklicken des Buttons „Zahlungspflichtig
bestellen“ deine Erklärung verbindlich im Sinne des § 3
Abs. 2 dieser AGB.</p>
              <h4>§ 5 Speicherung des Vertragstextes</h4>
              <p>Die Vertragsbestimmungen mit Angaben zu den bestellten Waren einschließlich dieser Allgemeinen Geschäftsbedingungen und der Widerrufsbelehrung werden
dir per E-Mail mit Annahme des Vertragsangebotes bzw. mit
der Benachrichtigung hierüber zugesandt. Eine Speicherung
der Vertragsbestimmungen durch uns erfolgt nicht.</p>
<h4>§ 6 Registrierung in unserem Online-Shop; Verarbeitung
deiner personenbezogenen Daten</h4>
              <p>(1) Du bist dazu verpflichtet im Rahmen der Registrierung
wahre und vollständige Angaben zu machen. Sollten sich
deine Angaben während der Vertragslaufzeit ändern, bist
du dazu verpflichtet, uns deine geänderten Angaben
unverzüglich mitzuteilen. Hierfür kannst du in deinem
Nutzerprofil deine Angaben jederzeit anpassen.</p>
<p>(2) Du bist dazu verpflichtet, deine Zugangsdaten geheim zu
halten. Eine Weitergabe der Zugangsdaten sowie die
Überlassung der Nutzmöglichkeit an andere Personen ist
unzulässig.</p>
<p>(3) Du darfst nur eine Registrierung gleichzeitig unterhalten.</p>
<p>(4) Du kannst in unserem Online-Shop Waren als Gast oder
als registrierter Benutzer bestellen. Als registrierter
Benutzer musst du nicht jedes Mal deine persönlichen
Daten angeben, sondern du kannst dich vor oder im
Rahmen einer Bestellung einfach mit deiner E-Mail-
Adresse und dem von dir bei Registrierung frei gewählten
Passwort in deinem Kundenkonto anmelden.</p>
<p>(5) Allein mit deiner Registrierung besteht keinerlei
Kaufverpflichtung hinsichtlich der von uns angebotenen
Waren.</p>
<p>(6) Für Informationen zur Verarbeitung deiner Daten lies bitte
unsere Datenschutzinformation, die du unter folgendem
Link https://shapebysarah.com/Datenschutz abrufen
kannst.</p>
              <h4>§ 7 Preise und Versandkosten</h4>
              <p>(1) Alle Preise in unserem Online-Shop sind in Euro (EUR)
und verstehen sich einschließlich der jeweils gültigen gesetzlichen Mehrwertsteuer, jedoch
ohne Versandkosten.</p>
<p>(2) Wir sind dazu berechtigt Versandkosten zu erheben. Die Versandkosten können je nach Ware und/oder
Versandart variieren. Die entsprechenden Versandkosten werden in der Bestellübersicht im
digitalen Warenkorb angegeben und werden von uns
gesondert auf der Rechnung ausgewiesen.</p>
<p>(3) Die Versandkosten sind von dir zu tragen, soweit du nicht
von deinem Widerrufsrecht nach § 12 dieser AGB
Gebrauch machst.</p>
<p>(4) Wir behalten uns das Recht vor etwaige Preisnachlässe,
Sonderangebote oder Rabatte jederzeit zu begrenzen
oder zu beenden.</p>
<h4>§ 8 Zahlungsbedingungen, Verzug</h4>
              <p>(1) Die Bezahlung der Ware erfolgt über einen der im
Bestellprozess angebotenen Zahlungswege.</p>
<p>(2) Der Kaufpreis wird sofort mit Bestellung fällig.</p>
<p>(3) Während eines Zahlungsverzugs von dir sind wir
berechtigt, Verzugszinsen in Höhe von 5 Prozentpunkten
über dem Basiszinssatz (§ 247 BGB) per annum zu
verlangen. Wir behalten uns den Nachweis eines höheren
Schadens ausdrücklich vor.</p>
<p>(4)Wir sind dazu berechtigt unter Einhaltung unserer
Datenschutzbestimmungen eine individuelle Kreditwürdigkeitsprüfung durchzuführen und bestimmte
Zahlungsmethoden auszuschließen.</p>
              <h4>§ 9 Eigentumsvorbehalt</h4>
              <p>Die Ware bleibt bis zu deiner vollständigen Bezahlung unser
Eigentum.</p>
<h4>§ 10 Lieferbedingungen, Warenverfügbarkeit</h4>
<p>(1) Das Liefergebiet für Bestellungen von Waren in unserem
Online-Shop umfasst Deutschland, Österreich, Italien,
Luxemburg, Niederlande und Schweiz.</p>
<p>(2) Wir liefern die Ware gemäß den mit dir getroffenen
Vereinbarungen. Soweit nicht ausdrücklich anders
vereinbart, bestimmen wir die angemessene Versandart
und das Transportunternehmen nach unserem billigen
Ermessen.</p>
<p>(3) Von uns angegebene Lieferzeiten berechnen sich vom
Zeitpunkt
unserer
Auftragsbestätigung
oder
Versandbestätigung, wobei eine vorherige Zahlung des
Kaufpreises vorausgesetzt ist. Die Lieferzeit beträgt dabei
voraussichtlich 3 bis 5 Werktage. Sollte sich die Lieferung
im Einzelfall verzögern, werden wir dich unverzüglich per
E-Mail über eine voraussichtlich neue Lieferzeit
informieren.</p>
<p>(4) Sofern du ein Verbraucher bist, geht die Gefahr des
zufälligen Untergangs, der zufälligen Beschädigung oder
des zufälligen Verlusts der gelieferten Ware in dem
Zeitpunkt auf dich über, in dem die Ware an dich
ausgeliefert wird oder du in Annahmeverzug geräts. In
allen anderen Fällen geht die Gefahr, sofern wir nur die
Versendung schulden, mit der Auslieferung der Ware an
das Transportunternehmen über.</p>
<p>(5) Bestellst du mehrere Waren, sind wir zu Teillieferungen
berechtigt – nicht jedoch verpflichtet – sodass du die
Ware schnellstmöglich erhalten kannst.</p>
<p>(6) Ist zum Zeitpunkt deiner Bestellung in unserem Online-
Shop bestellte Ware nicht verfügbar, behalten wir uns das
Recht vor, die Bestellung der Ware nicht anzunehmen, so
dass kein Vertrag zustande kommt. Hierrüber werden wir
dich per E-Mail informieren und etwaige bereits geleistete
Zahlungen unverzüglich erstatten.</p>
<p>(7) Ist von dir bestellte Ware nur vorübergehend nicht
verfügbar, werden wir dich auch hierrüber per E-Mail
informieren und dir mitteilen, wann du voraussichtlich mit
einer erneuten Warenverfügbarkeit rechnen kannst.</p>
<p>(8) Kommt es zu einer nicht von uns zu vertretenden
Nichtverfügbarkeit der von dir bestellten Ware nach
Vertragsschluss und infolge einer nicht rechtzeitigen oder
nicht richtigen Lieferung durch unseren Lieferanten trotz
eines mit dem Lieferanten geschlossenen Liefervertrags
über die bestellte Ware, behalten wir uns das Recht vor,
die von dir bestellte Ware nicht zu liefern. In diesem Fall
verpflichten wir uns dazu, dich über die Nichtverfügbarkeit
der Ware per E-Mail zu informieren und etwaige bereits
geleistete Zahlungen unverzüglich zu erstatten.</p>
<h4>§ 11 Besondere Bestimmungen bei E-Books</h4>
<p>(1) Ist Vertragsgegenstand ein E-Book, stellen wir dir
unmittelbar nach Zahlungseingang das E-Book im PDF-
Format zum Download bereit. Hierfür übersenden wir dir
einen Download-Link an die von dir angegebene E-Mail
Adresse. Zudem kannst du den Download-Link in deinem
Kundenkonto in unserem Online-Shop einsehen .</p>
<p>(2) Du bist dafür verantwortlich, die für den Download
erforderlichen technischen Voraussetzungen (z.B. eine
stabile Internetverbindung, geeignete Software zum
Öffnen
von
PDF-Dateien)
bereitzuhalten.
Für
Einschränkungen der Nutzbarkeit des E-Books, die auf
einer Nichterfüllung dieser Pflichten beruhen, können wir
keine Verantwortung übernehmen.</p>
<p>(3) Eine Weitergabe des E-Books an Dritte, eine
Vervielfältigung oder öffentliche Zugänglichmachung ist –
soweit nicht gesetzliche Bestimmungen dies ausdrücklich
erlauben – unzulässig. Das E-Book ist ausschließlich für
deinen persönlichen Gebrauch bestimmt.</p>
<h4>§ 12 Widerrufsrecht</h4>
<p>(1) Als Verbraucher steht dir nach Maßgabe der gesetzlichen
Bestimmungen gemäß § 312g i.V.m. § 355 BGB ein
Widerrufsrecht zu. Verbraucher ist jede natürliche
Person, die ein Rechtsgeschäft zu Zwecken abschließt,
die überwiegend weder ihrer gewerblichen noch ihrer
selbständigen beruflichen Tätigkeit zugerechnet werden
können.</p>
<p>(2) Machst du als Verbraucher von deinem Widerrufsrecht
Gebrauch, so hast du die Kosten der Rücksendung zu
tragen.</p>
<p>(3) Im Übrigen geltend für das Widerrufsrecht die
Regelungen, die im Einzelnen wiedergegeben sind in der
folgenden</p>
<h4>Widerrufsbelehrung</h4>
<h5>Widerrufsrecht</h5>
<p>Du hast das Recht, binnen vierzehn Tagen ohne Angabe
von Gründen diesen Vertrag zu widerrufen.</p>
<p>Die Widerrufsfrist beträgt vierzehn Tage ab dem Tag an
dem du oder ein von dir benannter Dritter, der nicht der
Beförderer ist, die Waren in Besitz genommen hast bzw.
hat.</p>
<p>Im Falle eines Vertrags über mehrere Waren, die Du im
Rahmen einer einheitlichen Bestellung bestellt hast und
die getrennt geliefert werden, beträgt die Widerrufsfrist
vierzehn Tage ab dem Tag, an dem Du oder ein von Dir
benannter Dritter, der nicht der Beförderer ist, die letzte
Ware in Besitz genommen haben bzw. hat.</p>
<p>Im Falle eines Vertrags über die Lieferung einer Ware in
mehreren Teilsendungen oder Stücken beträgt die
Widerrufsfrist vierzehn Tage ab dem Tag, an dem Du
oder ein von Dir benannter Dritter, der nicht der
Beförderer ist, die letzte Teilsendung oder das letzte
Stück in Besitz genommen haben bzw. hat.</p>
<p>Um dein Widerrufsrecht auszuüben, musst du uns
SHAPE BY SARAH ECOMMERCE – FZCO, Dubai Silicon Oasis, DDP, Building A1/A2, Dubai, United Arab
Emirates,
Telefon:<a href="tel:+491706794214">+491706794214</a>,
E-Mail:<a href="mailto: support@shapebysarah.com"> support@shapebysarah.com</a>, mittels einer eindeutigen
Erklärung (z.B. per E-Mail) über deinen Entschluss,
diesen Vertrag zu widerrufen, informieren. Du kannst
dafür das unten aufgeführte Muster-Widerrufsformular
verwenden, das jedoch nicht vorgeschrieben ist. Du
kannst das Muster-Widerrufsformular oder eine andere
eindeutige Erklärung auch auf unserer Webseite
www.shapebysarah.com elektronisch ausfüllen und
übermitteln. Machst du von dieser Möglichkeit Gebrauch,
so werden wir dir unverzüglich (z.B. per E-Mail) eine
Bestätigung über den Eingang eines solchen Widerrufs
übermitteln.</p>
<p>Zur Wahrung der Widerrufsfrist reicht es aus, dass du die
Mitteilung über die Ausübung des Widerrufsrechts vor
Ablauf der Widerrufsfrist absendest.</p>
<h5>Folgen des Widerrufs</h5>
<p>Wenn du diesen Vertrag widerrufst, haben wir dir alle Zahlungen, die wir von dir erhalten haben, einschließlich der Lieferkosten (mit Ausnahme der zusätzlichen Kosten, die sich daraus ergeben, dass du eine andere Art der Lieferung als die von uns angebotene, günstigste Standardlieferung gewählt hast), unverzüglich und spätestens binnen vierzehn Tagen ab dem Tag zurückzuzahlen, an dem die Mitteilung über deinen Widerruf dieses Vertrags bei uns eingegangen ist. Für diese Rückzahlung verwenden wir dasselbe Zahlungsmittel, das du bei der ursprünglichen Transaktion eingesetzt hast, es sei denn, mit dir wurde
ausdrücklich etwas anderes vereinbart; in keinem Fall
werden dir wegen dieser Rückzahlung Entgelte
berechnet. Wir können die Rückzahlung verweigern, bis
wir die Waren wieder zurückerhalten haben oder bis du
den Nachweis erbracht hast, dass du die Waren
zurückgesandt hast, je nachdem, welches der frühere
Zeitpunkt ist.</p>
<p>Du hast uns die Waren unverzüglich und in jedem Fall
spätestens binnen vierzehn Tagen ab dem Tag, an dem
du uns über den Widerruf dieses Vertrages unterrichtest,
an</p>
<p>Pvs eBusiness-Service GmbH<br/>
z.H. Wareneingang SHAPE<br/>
Daimlerst. 14<br/>
85748 Garching<br/>
Deutschland</p>
<p>zurücksenden. Die Frist ist gewahrt, wenn du die Waren
vor Ablauf der Frist von vierzehn Tagen absendest.</p>
<h5>Du trägst die unmittelbaren Kosten der Rücksendung
der Waren.</h5>
<p>Du musst für einen etwaigen Wertverlust der Waren nur
aufkommen, wenn dieser Wertverlust auf einen zur
Prüfung der Beschaffenheit, Eigenschaften und
Funktionsweise der Waren nicht notwendigen Umgang
mit ihnen zurückzuführen ist.</p>
{/* <p>(4) Wenn du den Vertrag widerrufen möchtest, kannst du auch
unser digitales Widerrufsformular unter https://shapebysarah.com/Widerrufsformular nutzen oder
folgendes Muster Widerrufsformular ausfüllen und an uns zurücksenden:</p> */}
<p>Beim Kauf eines E-Books als Download nach Maßgabe des § 11 dieser AGB verzichtest du ausdrücklich auf dein
Widerrufsrecht, sobald wir mit der Ausführung des Vertrags begonnen haben. Der Beginn der
Vertragsausführung erfolgt durch uns sobald wir dir den
Download-Link zur Verfügung stellen. Voraussetzung für
einen wirksamen Verzicht auf dein Widerrufsrecht ist
allerdings, dass du zuvor ausdrücklich zustimmst, dass
wir vor Ablauf der Widerrufsfrist mit der Vertragserfüllung
beginnen dürfen und du deine Kenntnis davon bestätigt hast, dass du durch deine Zustimmung dein
Widerrufsrecht verlierst.</p>
<h4>§ 13 Gewährleistung bei Warenkäufen</h4>
<p>(1) Soweit die in unserem Online-Shop gekaufte und
gelieferte Ware mangelhaft ist, bist du im Rahmen der
gesetzlichen Bestimmungen berechtigt, Nacherfüllung zu
verlangen, von dem Vertrag zurückzutreten oder den
Kaufpreis zu mindern.</p>
<p>(2) Die Verjährungsfrist von Gewährleistungsansprüchen für
die gelieferte Ware beträgt zwei Jahre ab Erhalt der Ware
gegenüber Verbrauchern und ein Jahr gegenüber
Unternehmern. Ansprüche wegen Mängeln, die wir
arglistig verschwiegen haben, verjähren innerhalb der
regelmäßigen Verjährungsfrist.</p>
<p>(3) Rechte wegen Mängeln stehen dir darüber hinaus auch
im Rahmen einer Beschaffenheits- und/oder Haltbarkeitsgarantie zu, sofern wir eine solche bezüglich
der verkauften Ware im Einzelfall ausdrücklich
abgegeben haben.</p>
<h4>§ 14 Haftungsbeschränkung</h4>
<p>(1) Wir haften für Vorsatz und grobe Fahrlässigkeit. Ferner
haften wir für die fahrlässige Verletzung von Pflichten,
deren Erfüllung die ordnungsgemäße Durchführung des
Vertrags überhaupt erst ermöglicht, deren Verletzung die
Erreichung des Vertragszweckes gefährdet und auf deren
Einhaltung du als Kunde regelmäßig vertrauen darfst. Im
letztgenannten Fall haften wir jedoch nur für den
vorhersehbaren, vertragstypischen Schaden. Gleiches
gilt für Pflichtverletzungen unserer Erfüllungsgehilfen.</p>
<p>(2) Die vorstehenden Haftungsausschlüsse gelten nicht bei
Verletzung von Leben, Körper und Gesundheit. Die
Haftung nach dem Produkthaftungsgesetz bleibt
unberührt.</p>
<h4>§ 15 Urheberrechte</h4>
<p>Wir haben an allen Bildern, Filmen und Texten, die in unserem
Online-Shop veröffentlicht werden, Urheberrechte. Eine
Verwendung der Bilder, Filme und Texte, ist ohne unsere
ausdrückliche Zustimmung nicht gestattet.</p>
<h4>§ 16 Schlussbestimmungen</h4>
<p>(1) Sollten einzelne Bestimmungen dieses Vertrags
unwirksam sein, so wird hierdurch der Vertrag im Übrigen
nicht berührt. An die Stelle der unwirksamen Bestimmung
treten, soweit vorhanden, die gesetzlichen Vorschriften.</p>
<p>(2) Zur Teilnahme an einem Streitbeilegungsverfahren nach
dem Verbraucherstreitbeilegungsgesetz (VSBG) sind wir
nicht verpflichtet und nicht bereit.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Agb